export default {
    data() {
        return {
            alert: {
                isshow: false,
            },
            isLogin: this.$isLogin(), //是否登录
            orderNum: this.$route.params.ordernum, //订单编号
            curTabId: parseInt(this.$route.query.tabid), //当前激活选项卡
            //来源页面：0:不确认,1:我的订单列表
            fromPage: this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 0,
            orderStatus: [{
                    id: 1,
                    name: "等待确认",
                    selected: true
                },
                {
                    id: 2,
                    name: "面试订单",
                    selected: false
                },
                {
                    id: 3,
                    name: "成交订单",
                    selected: false
                },
            ],
            detailData: {},
            inviteList: [],
            jobType: 0,
            dealId: 0, //成交阿姨Id
            dealAmount: "", //成交金额
            dealDate: "", //成交日期
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'releaseClientJobDetail') {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.isLogin = this.$isLogin(); //是否登录
            this.orderNum = this.$route.params.ordernum;
            this.curTabId = parseInt(this.$route.query.tabid);
            this.dealAmount = "";
            this.dealDate = "";
            this.inviteList = [];
            this.getDetail();
        },
        //获取详情数据
        getDetail() {
            var self = this;
            this.$post("/customerservicemanager/getpublishjobdetail", {
                JobId: self.orderNum,
            }, function(ret) {
                if (ret.Success) {
                    self.detailData = ret.Result.CustomerJob;

                    let status = self.detailData.Status;
                    self.jobType = self.detailData.JobType;

                    self.detailData.ListJobServant.map((item, index) => {
                        item.Checked = false;
                    });

                    self.inviteList = [];
                } else {
                    self.$toast(ret.Message);
                }
            });
        },
        //查看详情
        viewDetail(servantId,jobApplicationId) {
            let self = this;
            let _param = {
                jobType: this.jobType,
                platform: 2,
                fromPage: 4,
            };
            if(self.detailData.Status == 5 || self.detailData.Status == 10){
                _param.handleType = 2;
                _param.jobApplicationId = jobApplicationId;
            } else {
                _param.handleType = 0;
                _param.jobApplicationId = 0;
            }
            this.$router.push({
                path: "/serverDetail/" + servantId + "/" + self.detailData.JobId,
                query: _param
            });
        },
        //邀请选择
        chgInvite(srvIdx) {
            let self = this;
            var servant = self.detailData.ListJobServant[srvIdx];
            servant.Checked = !servant.Checked;
            //多选
            // if (self.inviteList && self.inviteList.length > 0) {
            //     self.inviteList.map((item, index) => {
            //         if (item == servant.JobApplicationId) {
            //             if (servant.Checked) {
            //                 self.inviteList.splice(index, 1);
            //             } else {
            //                 self.inviteList.push(servant.JobApplicationId);
            //             }
            //         }
            //     });
            // } else {
            //     if (servant.Checked) {
            //         self.inviteList.push(servant.JobApplicationId);
            //     }
            // }
            // self.detailData.ListJobServant.splice(srvIdx, 1, servant);
            //单选
            self.inviteList = [];
            if (servant.Checked) {
                self.inviteList.push(servant.JobApplicationId);
            }
            if (self.detailData.ListJobServant && self.detailData.ListJobServant.length > 0) {
                self.detailData.ListJobServant.map((item, index) => {
                    let newItem = item;
                    if (item.JobApplicationId == servant.JobApplicationId && servant.Checked) {
                        newItem.Checked = true;
                    } else {
                        newItem.Checked = false;
                    }
                    self.detailData.ListJobServant.splice(index, 1, newItem);
                });
            }
        },
        //提交邀请
        subInvite() {
            let self = this;
            if (!this.inviteList || this.inviteList.length <= 0) {
                this.selfAlert("请先选择服务人员");
                return false;
            }
            for(let i=0; i<self.detailData.ListJobServant.length; i++){
                if(self.detailData.ListJobServant[i].JobApplicationId == parseInt(this.inviteList[0])){
                    self.viewDetail(self.detailData.ListJobServant[i].ServantId,self.detailData.ListJobServant[i].JobApplicationId);
                    break;
                }
            }
            return false;
            let _param = {
                JobId: this.orderNum,
                JobApplicationId: this.inviteList
            };
            this.$post(self.$API.accountSendInvitation, _param, function(ret) {
                if (ret.Success) {
                    self.selfAlert("请等待客服经理回电！");
                    self.$router.push({
                        path: "/release/clientJobList/2",
                        query: {}
                    });
                } else {
                    self.$toast(ret.Message);
                }
            });
        },

        //确认成交
        confirmDeal(id) {
            let self = this;
            this.dealId = id;
            self.alert = {
                cont: "",
                cancelauto: true,
                callback: self.doDeal,
                isCustomClose: true,
                isSlot: true,
                isOperation: true,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
        doDeal() {
            if (!this.dealAmount || this.dealAmount == "" || this.dealAmount <= 0) {
                alert("请按合同金额正确输入");
                return false;
            } else if (!this.dealDate || this.dealDate == "") {
                alert("请输入成交日期");
                return false;
            }
            //提交数据
            console.log(this.dealId);

            //提交后关闭对话框
            this.alert = {
                isshow: false,
            };
        },

        //自定义返回
        customBack() {
            if (this.fromPage && this.fromPage == 1) {
                this.$router.push({
                    path: "/release/clientJobList/" + this.curTabId,
                    query: {

                    }
                });
            }
        },

        //提示
        selfAlert(cont, callback) {
            let self = this;
            self.alert = {
                cont: cont,
                callback: callback ? callback : false,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
    },
}



// WEBPACK FOOTER //
// ./src/ally/page/release/clientJobDetail.js